import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=791b93b8&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=ts&"
export * from "./Language.vue?vue&type=script&lang=ts&"
import style0 from "./Language.vue?vue&type=style&index=0&id=791b93b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791b93b8",
  null
  
)

export default component.exports